import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import InitiativeDuplicationToast from '../../components/initiatives/duplicate/InitiativeDuplicationToast.jsx';
import { pushRoute } from '../../lib/router.js';
import {
  clearInitiativeCopy,
  hideInitiativeCopyToast,
  selectInitiativeCopy,
  selectInitiativeCopyToastShown,
} from '../../modules/initiativeDuplications.js';

const mapStateToProps = (state) => ({
  copy: selectInitiativeCopy(state),
  toastShown: selectInitiativeCopyToastShown(state),
});

const mapDispatchToProps = {
  clearInitiativeCopy,
  hideInitiativeCopyToast,
};

// Shows the success message of the last initiative duplication. The copy belongs to
// the page it was made on: leaving that page drops the message and the "New copy" mark.
const InitiativeCopyWatcher = ({
  copy,
  toastShown,
  clearInitiativeCopy,
  hideInitiativeCopyToast,
}) => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (copy && copy.path !== pathname) clearInitiativeCopy();
  }, [pathname]);

  if (!copy || !toastShown || copy.path !== pathname) return null;

  const onOpen = () =>
    pushRoute('initiatives/show', {
      initiativeType: copy.type,
      initiativeId: copy.id,
    });

  return (
    <InitiativeDuplicationToast
      title={copy.title}
      targetProjectName={
        copy.projectId === copy.sourceProjectId ? null : copy.projectName
      }
      onOpen={onOpen}
      onClose={hideInitiativeCopyToast}
    />
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InitiativeCopyWatcher);
